import { createContext } from 'react'

export type DndCustomContextType = {
  isDragging: boolean
  setIsDragging: (value: boolean) => void
  isTouchDevice: boolean
}

export const initialStateDndCustomContext: DndCustomContextType = {
  isDragging: false,
  setIsDragging: () => {},
  isTouchDevice: false,
}

export const DndCustomContext = createContext<DndCustomContextType>(initialStateDndCustomContext)
